import styled from 'styled-components'
import { styled as muiStyled } from '@mui/system'
import {
  Button,
  ButtonBase,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputBase,
  Link,
  Paper,
} from '@mui/material'

export const ClinicPublicPageLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 50px 12px 0;
`

export const ClinicPageSubtitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  @media (min-width: 480px) {
    font-size: 20px;
  }
`

export const ClinicPageTitle = styled.div`
  font-size: 38px;
  line-height: 48px;
  font-weight: 500;
  @media (min-width: 480px) {
    font-size: 74px;
    line-height: 84px;
  }
  @media (min-width: 768px) {
    width: 100%;
    font-size: 74px;
    line-height: 84px;
  }
`

export const ClinicPageInfo = styled.div`
  font-size: 17px;
  line-height: 23px;
  width: 80%;
  margin-top: 20px;
  margin-bottom: 32px;
`

export const ClinicPageBecomeClinicButton = muiStyled(ButtonBase)(
  ({ theme }) => `
  padding: 12px 27px;
  font-size: 20px;
  background-color: #8247f5;
  border-radius: 7px;
  color: white;
  z-index: 2;
`,
)

export const ClinicPagePrimaryWidgetItemsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 20px;
  padding: 30px;
  @media (min-width: 768px) {
    padding: 90px 30px;
    flex-direction: row;
    justify-content: space-between;
  }
`

export const ClinicPagePrimaryWidgetBackground = styled.img`
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  @media (min-width: 768px) {
    max-width: 500px;
  }
`

export const ClinicPublicPageContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`

export const ClinicPublicPageJoinClinicInput = muiStyled(InputBase)(
  ({ theme }) => `
  border-radius: 20px;
  border: 1px solid green;
`,
)

export const ClinicOnboardingFormComponent = muiStyled('form')(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: stretch;
  gap: 20px;
`,
)

export const ClinicJoinModalContent = muiStyled(DialogContent)(
  ({ theme }) => `
`,
)

export const StyledDialogPaper = muiStyled(Paper)`
position: relative;
text-align: center;
border-radius: 20px;
padding: 25px 13px 26px;
font-family: Outfit !important;
width: 550px;
max-height: none !important;
@media (min-width: 576px) {
  padding: 62px 90px 86px;
}
`

export const StyledDialogTitle = muiStyled(DialogTitle)`
    font-family: inherit !important;
    font-size: 1.75rem !important;
`

export const StyledDialogActions = muiStyled(DialogActions)`
    display: flex;
    align-items: center;
    justify-content: stretch;
`

export const StyledDialogSingleAction = muiStyled('div')`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
    width: 100%;
`

export const StyledEmailNotVerifiedMessage = muiStyled('div')(
  ({ theme, verifyEmail }) => `
  color: ${verifyEmail ? 'black' : '#ff3939ed'};
  padding: 12px 0px 0px 0px;
`,
)

export const StyledDialogJoinButton = muiStyled(Button)`
background: ${({ theme, disabled }) =>
  disabled ? '#a09e9e' : 'linear-gradient(149deg, #6977df 0%, #ca98ff 100%)'};
color: ${({ theme, disabled }) => (disabled ? '#e5e5e5' : '#fff')} !important;
font-family: inherit;
text-transform: none;
width: 100%;
padding: 10px;
font-size: 16px;
font-weight: 400;
border-radius: 13px;
`

export const StyledDialogVerifiedButton = muiStyled(Button)`
background: ${({ theme, disabled }) => (disabled ? '#a09e9e' : '#8247f5')};
color: ${({ theme, disabled }) => (disabled ? '#e5e5e5' : '#fff')} !important;
font-family: inherit;
text-transform: none;
width: 100%;
padding: 10px;
font-size: 16px;
font-weight: 400;
border-radius: 13px;
:hover {
  background-color: #905bf7;
};
`

export const StyledClinicJoinVerifyLink = muiStyled(Link)`
cursor: pointer;
`

export const StyledClinicJoinVerifyLinkAfter = muiStyled('div')`
`

export const StyledClinicEmailInputAndMessageContainer = muiStyled('div')`
  display: flex;
  justify-content: stretch;
  align-items: center;
  width: 100%;
  gap: 20px;
  background: ${({ invalid }) => (invalid ? '#edbbbb' : '#ebebeb')};
  padding: 10px;
  border-radius: 7px;
`
